import { useEffect } from 'react';
import { Link } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { NoProducts } from 'components/ProductItems/NoProducts';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useAmplitude } from 'hooks/useAmplitude';
import { useNavigate } from 'react-router-dom';
import { getCookie } from 'utils/cookieHelper';
import { deriveProductFromTypeAndDuration } from 'utils/productHelper';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from '../Products.module.css';
import { DocumentRequirementsDE } from './DocumentRequirementsDE/DocumentRequirementsDE';
import { FlexiKreditFeatures } from './FlexiKreditFeatures/FlexiKreditFeatures';
import { FlexiKreditProcess } from './FlexiKreditProcess/FlexiKreditProcess';
import { MinimumCriteriaDE } from './MinimumCriteriaDE/MinimumCriteriaDE';
import { OnboardingInReviewDE } from './OnboardingInReviewDE/OnboardingInReviewDE';

export const ProductsDE = () => {
  const navigate = useNavigate();
  const { trackEvent } = useAmplitude();
  const { introducerCompany, isContextError, hasOnboardingFilesUploaded } =
    useIntroducerData();

  useEffect(() => {
    if (isContextError) {
      navigate(PATH_NAMES.notFound());
    }
  }, [isContextError, navigate]);

  const handleApply = () => {
    const productName = deriveProductFromTypeAndDuration({
      productType: 'credit_facility',
      isUK: false,
    }).name;

    trackEvent(AMPLITUDE_EVENTS.signupCTAClicked, {
      'CTA location': 'Products',
      'CTA text': `Apply for a ${productName}`,
      'CTA URL': PATH_NAMES.newApplicationStep0(),
    });
    navigate(PATH_NAMES.newApplicationStep0());
  };

  if (isContextError || !introducerCompany) {
    return null;
  }

  const hasNoProducts = introducerCompany.available_products.length === 0;
  const showDocsInReview =
    getCookie('showDocsInReview') === 'true' &&
    Boolean(hasOnboardingFilesUploaded);

  return (
    <div className={styles.container}>
      {hasNoProducts ? (
        showDocsInReview ? (
          <OnboardingInReviewDE />
        ) : (
          <NoProducts />
        )
      ) : (
        <>
          <FlexiKreditFeatures />
          <MinimumCriteriaDE onApply={handleApply} />
          <DocumentRequirementsDE />
          <FlexiKreditProcess onApply={handleApply} />
        </>
      )}
      <Link
        className={clsx(styles.termsLink, {
          [styles.termsLinkNoProducts]: hasNoProducts,
        })}
        href="https://static.iwoca.com/pdf/de/iwoca_Partner_AGB_v20240816.pdf"
        target="_blank"
        rel="noreferrer"
      >
        <Trans>Terms and conditions</Trans>
      </Link>
    </div>
  );
};
